import { render, staticRenderFns } from "./ModalMatrizRiscos.vue?vue&type=template&id=5bf9e689&scoped=true"
import script from "./ModalMatrizRiscos.vue?vue&type=script&lang=js"
export * from "./ModalMatrizRiscos.vue?vue&type=script&lang=js"
import style0 from "./ModalMatrizRiscos.vue?vue&type=style&index=0&id=5bf9e689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9e689",
  null
  
)

export default component.exports